import { getSelector, getLines } from './getSelector'
import lastEvent from './getLastEvent'

const getJavaScriptError = (call) => {
  window.addEventListener('error', (res) => {
    const { message, filename, type, lineno, colno } = res
    console.log('error', res)
    call && call({
      msg: message,
      url: filename,
      type,
      time: new Date().getTime(),
      filename,
      position: `${lineno}:${colno}`,
      stack: getLines(res.error.stack),
      selector: lastEvent ? getSelector(lastEvent.path) : ''
    })
  })
}

const getJavaScriptAsyncError = (call) => {
  window.addEventListener('unhandledrejection', (e) => {
    console.log('unhandledrejection', e)
    call && call({
      type: 'promise',
      msg: (e.reason && e.reason.msg) || e.reason || '',
      time: new Date().getTime()
    })
  })
}

export { getJavaScriptError, getJavaScriptAsyncError }
